import {useQuery} from 'react-query'
import {BalanceEditModalForm} from './BalanceEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getBalanceById} from '../core/_requests'

const BalanceEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: balance,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-balance-${itemIdForUpdate}`,
    () => {
      return getBalanceById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <BalanceEditModalForm isBalanceLoading={isLoading} balance={{id: undefined}} />
  }

  if (!isLoading && !error && balance) {
    console.log({balance, },"its balance")
    console.log(typeof balance,"its balance")
    return <BalanceEditModalForm isBalanceLoading={isLoading} balance={balance} />
  }

  return null
}

export {BalanceEditModalFormWrapper}
